import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { saasApi, type SaaSDashboard } from '../../api/saas';

const NAV = [
  { to: '/saas/tenants', label: 'Tenant Manager' },
  { to: '/saas/organizations', label: 'Organization Manager' },
  { to: '/saas/branding', label: 'Branding Center' },
  { to: '/saas/provisioning', label: 'Provisioning Center' },
  { to: '/saas/support', label: 'Support Console' },
  { to: '/saas/health', label: 'Tenant Health' },
  { to: '/saas/analytics', label: 'Tenant Analytics' },
  { to: '/saas/whitelabel', label: 'White Label Manager' },
  { to: '/saas/marketplaces', label: 'Marketplace Manager' },
];

export function SaaSHubPage() {
  const [dashboard, setDashboard] = useState<SaaSDashboard | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    void saasApi.dashboard().then(setDashboard).catch((e) => setError(String(e)));
  }, []);

  const stats = dashboard
    ? [
        { label: 'Total Tenants', value: dashboard.total_tenants },
        { label: 'Active', value: dashboard.active_tenants },
        { label: 'Suspended', value: dashboard.suspended_tenants },
        { label: 'Organizations', value: dashboard.total_organizations },
        { label: 'Total Users', value: dashboard.total_users },
        { label: 'Storage (GB)', value: dashboard.total_storage_gb.toFixed(1) },
        { label: 'AI Credits', value: dashboard.total_ai_credits.toFixed(0) },
        { label: 'Pending', value: dashboard.pending_tenants },
      ]
    : [];

  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold">Global SaaS Dashboard</h1>
      <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">
        Enterprise SaaS administration, tenant operations, organization management and white-label platform.
      </p>
      <nav className="mt-4 flex flex-wrap gap-3 text-sm">
        {NAV.map((l) => (
          <Link key={l.to} to={l.to} className="text-slate-700 hover:underline dark:text-slate-300">{l.label}</Link>
        ))}
      </nav>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {stats.map((s) => (
          <div key={s.label} className="rounded-xl border bg-white p-4 dark:border-slate-700 dark:bg-slate-900">
            <p className="text-sm text-slate-500">{s.label}</p>
            <p className="mt-1 text-2xl font-semibold">{String(s.value ?? 0)}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
